<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a>IMAGES OF WAR</h1>
<p class="stitle"><span class="bold">GERMAN ARMOUR LOST</span></p>
<p class="stitle"><span class="bold">ON THE WESTERN FRONT</span></p>
<p class="stitle1">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</p>
<p class="noindent"><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?a7ebd15a